"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
var classnames_1 = __importDefault(require("classnames"));
require("react-bootstrap-table-next/dist/react-bootstrap-table2.min.css");
require("./SzTable.scss");
var SzTable = function (_a) {
    var data = _a.data, columns = _a.columns, className = _a.className, defaultSorted = _a.defaultSorted, keyField = _a.keyField, rowEvents = _a.rowEvents, rowClasses = _a.rowClasses, sticky = _a.sticky;
    var tableClasses = classnames_1.default('sz-table bg-white', className, { sticky: sticky });
    var targetRef = react_1.useRef(null);
    react_1.useEffect(function () {
        var ref = targetRef.current;
        if (ref) {
            var head = ref.querySelector('thead tr.sz-table-header');
            var headHeight = head === null || head === void 0 ? void 0 : head.clientHeight;
            var lastChild = head.querySelector('th:last-child');
            lastChild.style.height = headHeight + "px";
            setTimeout(function () {
                var e_1, _a;
                try {
                    for (var _b = __values(ref.querySelectorAll('tbody tr')), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var line = _c.value;
                        var lineHeight = line.querySelector('td:first-child').clientHeight;
                        line.lastElementChild.style.height = lineHeight + "px";
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }, 500);
        }
    }, []);
    react_1.useEffect(function () {
        var ref = targetRef.current;
        if (ref) {
            var tableSelector_1 = ref.querySelector('.react-bootstrap-table');
            var scrollWidth_1 = tableSelector_1.scrollWidth, clientWidth_1 = tableSelector_1.clientWidth;
            var handleScroll_1 = function (_a) {
                var currentTarget = _a.currentTarget;
                var scrollLeft = currentTarget.scrollLeft;
                var table = ref.querySelector('.sz-table');
                if (scrollWidth_1 - scrollLeft <= clientWidth_1) {
                    table.classList.add('ended');
                }
                else {
                    table.classList.remove('ended');
                }
            };
            tableSelector_1.addEventListener('scroll', handleScroll_1);
            return function () {
                tableSelector_1.removeEventListener('scroll', handleScroll_1);
            };
        }
        return;
    }, []);
    return (react_1.default.createElement("div", { ref: targetRef },
        react_1.default.createElement(react_bootstrap_table_next_1.default, { bootstrap4: true, rowClasses: rowClasses, keyField: keyField, rowEvents: rowEvents, data: data, columns: columns, defaultSorted: defaultSorted, headerClasses: "sz-table-header border-0 bg-light-blue", classes: tableClasses, wrapperClasses: "w-100", bordered: false })));
};
exports.default = SzTable;
